(function (mdcdot_user, $, app, undefined) {
  // Private object
  var __this = {};
  mdcdot_user.updateCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }

  };


  mdcdot_user.payloadProcessor =  function (requestData) {
    $('.social-input').each(function ()  {
      const $this = $(this);
      const value = $this.val();
      if(!app.isEmpty(value)) {
        requestData[$this.attr('name')] = $this.data('prefix') + value;
        if($this.data('suffix')) {
          requestData[$this.attr('name')] = $this.data('prefix') + value + $this.data('suffix');
        }
      }

    })
    return requestData;

  }

  mdcdot_user.setting =  {
    init :function () {
      app.initSimpleBar(document.getElementById('tab_block_2'));
      const $form =  $('form[name="dot-user-setting"]');
      const $emailDelaySwitch = $form.find(':input[name="emailDelay"]');
      Utils.setSwitchVal($emailDelaySwitch, $emailDelaySwitch.is(":checked"), true);
    },
    setDotUserValues : function () {
      $('.social-input').each(function ()  {
        const $this = $(this);
        $this.val($this.val().replace($this.data('prefix'), ''));
      })
    },

  }

  mdcdot_user.scoringPayloadProcessor =  function (requestData) {
    return requestData;
  }

  mdcdot_user.scoringCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    if (!app.isEmpty(app.notifyEl)) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }
  };

  mdcdot_user.scoring =  {
    init :function () {
      app.initSimpleBar(document.getElementById('tab_block_3'));
      const $form =  $('form[name="dot-user-setting"]');
      const $emailDelaySwitch = $form.find(':input[name="emailDelay"]');
      Utils.setSwitchVal($emailDelaySwitch, $emailDelaySwitch.is(":checked"), true);
    },
    setDotUserValues : function () {
      $('.social-input').each(function ()  {
        const $this = $(this);
        $this.val($this.val().replace($this.data('prefix'), ''));
      })
    },

  }




}(window.mdcdot_user = window.mdcdot_user || {}, jQuery, PreBuilt));

